import { ProcessingFlow } from '@/features/processing';

interface ProcessingStepProps {
  onAdvance: () => void;
}

/** Full-bleed quiz step wrapping the estimating → results processing flow. */
export function ProcessingStep({ onAdvance }: ProcessingStepProps) {
  return <ProcessingFlow onContinue={onAdvance} />;
}
